import {LeafletClusterProps} from "@ui/leafletCustom/leafletCluster/types";
import {transformEventName} from "@ui/leafletCustom/leafletCluster/helpers/transformEventName";
import {MarkerClusterGroup} from 'leaflet'

export function createMarkerCluster({children: _c, ...props}: LeafletClusterProps, context: any) {

    const clusterProps: Record<string, any> = {}
    const clusterEvents: Record<string, any> = {}

    Object.entries(props).forEach(([propName, prop]) => propName.startsWith('on') ? (clusterEvents[propName] = prop) : (clusterProps[propName] = prop))

    const instance = new MarkerClusterGroup(clusterProps)

    Object.entries(clusterEvents).forEach(([eventAsProp, callback]) => {
        const clusterEvent = transformEventName(eventAsProp)
        instance.on(clusterEvent, callback)
    })
    return {
        instance,
        context: {
            ...context,
            layerContainer: instance,
        },
    }
}

